import { render, staticRenderFns } from "./AddProject.vue?vue&type=template&id=4b49f217&"
import script from "./AddProject.vue?vue&type=script&lang=ts&"
export * from "./AddProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddProject.vue"
export default component.exports